import * as React from "react";
import ImageSlider from "../../components/image-slider/ImageSlider";
import { IImages } from "../../components/image-slider/ImageSlider.types";
import Builder from "../../../static/cooperation/builder.png";
import Dolcevita from "../../../static/cooperation/dolcevita.png";
import NowaBasn from "../../../static/cooperation/nowabasn.png";
import Nowaeres from "../../../static/cooperation/nowaeres.png";
import Slowni from "../../../static/cooperation/slowni.png";
import { configCooperationSlider } from "./config";

const CooperationSlider = () => {
  const cooperators: IImages[] = [
    {
      imagePath: Builder,
      description: "Builder",
    },
    {
      imagePath: Dolcevita,
      description: "Dolcevita",
    },
    {
      imagePath: NowaBasn,
      description: "NowaBasn",
    },
    {
      imagePath: Nowaeres,
      description: "Nowaeres",
    },
    {
      imagePath: Slowni,
      description: "Slowni",
    },
  ];

  return (
    <div className="relative left-[50%] -translate-x-[50%] bg-gray-4 w-full laptop:w-screen">
      <div className="w-full mx-auto laptop:max-w-[1302px] desktop:max-w-[1440px]">
        <div className="flex flex-col tablet:flex-row items-center gap-x-20 gap-y-6 px-4 m-auto py-[42px] tablet:py-[72px] [&_img]:h-[32px] [&_img]:m-auto [&_img]:grayscale ">
          <span className="shrink-0 text-base">Moi klienci:</span>
          <ImageSlider
            images={cooperators}
            customConfig={configCooperationSlider}
          />
        </div>
      </div>
    </div>
  );
};

export default CooperationSlider;
